import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef, useContext, useId } from 'react';
import { getCommonClassNameDefault } from '@skatteetaten/ds-core-utils';
import { RadioGroupContext } from '../RadioGroupContext/index.esm.js';
import './styles.css';


var styles = {
    "radio": "Radio-module_radio__GkgeJ",
    "radioInput": "Radio-module_radioInput__NA-KA",
    "radioLabel": "Radio-module_radioLabel__9UxvD",
    "radioLabelDescription": "Radio-module_radioLabelDescription__Omm8c"
};

const Radio = /*#__PURE__*/ forwardRef(({ id: externalId, className = getCommonClassNameDefault(), lang, 'data-testid': dataTestId, description, form, value, ariaDescribedby, children, onBlur, onChange, onFocus }, ref)=>{
    const context = useContext(RadioGroupContext);
    const uniqueInputId = `radioInputId-${useId()}`;
    const inputId = externalId ?? uniqueInputId;
    const concatenatedClassName = `${styles.radio} ${className}`.trim();
    const ariaDescribedbyInput = `${ariaDescribedby ?? ''} ${context?.errorId ?? ''}`.trim();
    const onChangeInput = (event)=>{
        context?.onChange && context.onChange(event);
        onChange && onChange(event);
    };
    const onBlurInput = (event)=>{
        context?.onBlur && context.onBlur(event);
        onBlur && onBlur(event);
    };
    const onFocusInput = (event)=>{
        onFocus && onFocus(event);
    };
    return /*#__PURE__*/ jsxs("div", {
        className: concatenatedClassName,
        lang: lang,
        children: [
            /*#__PURE__*/ jsx("input", {
                ref: ref,
                id: inputId,
                className: styles.radioInput,
                "data-testid": dataTestId,
                checked: context?.selectedValue === undefined ? undefined : context?.selectedValue === value,
                defaultChecked: context?.defaultValue === undefined ? undefined : context?.defaultValue === value,
                form: form,
                value: value,
                type: 'radio',
                name: context?.name,
                required: context?.required,
                "aria-describedby": ariaDescribedbyInput || undefined,
                "aria-invalid": context?.hasError,
                onBlur: onBlurInput,
                onChange: onChangeInput,
                onFocus: onFocusInput
            }),
            /*#__PURE__*/ jsxs("label", {
                className: styles.radioLabel,
                htmlFor: inputId,
                tabIndex: -1,
                children: [
                    children,
                    description && /*#__PURE__*/ jsxs(Fragment, {
                        children: [
                            " ",
                            /*#__PURE__*/ jsx("span", {
                                className: styles.radioLabelDescription,
                                children: description
                            })
                        ]
                    })
                ]
            })
        ]
    });
});
Radio.displayName = 'Radio';

export { Radio };
